import PublicLayout from "../../modules/ui/components/PublicLayout";
import React from "react";
import ProfileView from "./ProfileView";

const PageProfile = () => {
    return (
        <PublicLayout>
            <div className={`nc-CheckOutPage`} data-nc-id="CheckOutPage">
                <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
                    <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10 "><ProfileView/></div>
                </main>
            </div>
        </PublicLayout>
    );
}

export default PageProfile;
